export const cardStatusTagStyles = {
	// Mantém o label do badge em uma linha — evita a quebra no mobile em labels longos
	// (ex.: "Anúncio desativado", "Pagamento não autorizado"). ANCR-5410.
	wrapper: 'inline-flex whitespace-nowrap'
} as const;
